module.exports = __webpack_public_path__ + "static/fonts/iconfont.4bb6391e.woff2";